// extracted by mini-css-extract-plugin
export default {"inaccessibleSectionContainer":"LargeScreenAccessiblePageOnly_inaccessibleSectionContainer__HgjY8"};